export const categories = [
  {
    slug: 'society',
    name: '社会',
    icon: 'ri-community-line',
    description: '聚焦城市治理、民生服务、教育医疗与社会百态，记录正在发生的社会脉动。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20urban%20community%20with%20renovated%20residential%20buildings%20green%20public%20space%20and%20warm%20daylight%20documentary%20photography&width=800&height=560&seq=hs-cat-society&orientation=landscape',
  },
  {
    slug: 'entertainment',
    name: '娱乐',
    icon: 'ri-movie-2-line',
    description: '追踪影视、音乐、综艺与演出的最新动态，第一时间掌握文娱市场热点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinema%20and%20stage%20with%20warm%20spotlight%20red%20curtain%20film%20reels%20artistic%20cinematic%20atmosphere&width=800&height=560&seq=hs-cat-ent&orientation=landscape',
  },
  {
    slug: 'technology',
    name: '科技',
    icon: 'ri-cpu-line',
    description: '关注人工智能、芯片、智能硬件与前沿技术，洞察科技产业演进趋势。',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20technology%20lab%20with%20glowing%20circuit%20lines%20and%20semiconductor%20chip%20macro%20clean%20high%20tech%20aesthetic&width=800&height=560&seq=hs-cat-tec&orientation=landscape',
  },
];